import MeasurementWidgetContainer from './MeasurementWidgetContainer';
import IWidgetProps from './IWidgetProps';

export default MeasurementWidgetContainer;

export {
    MeasurementWidgetContainer,
    IWidgetProps,
}


// WEBPACK FOOTER //
// ./src/components/widget/MeasurementWidgetContainer/index.tsx